import { render, staticRenderFns } from "./scope71.vue?vue&type=template&id=5470bf8f&scoped=true"
import script from "./scope71.vue?vue&type=script&lang=js"
export * from "./scope71.vue?vue&type=script&lang=js"
import style0 from "./scope71.vue?vue&type=style&index=0&id=5470bf8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470bf8f",
  null
  
)

export default component.exports